/* eslint-disable camelcase */
import React, { memo, useCallback, useState } from 'react';
import PropTypes from 'prop-types';
import { Button, Col, Row } from 'react-bootstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCalculator } from '@fortawesome/free-solid-svg-icons';
import { dataPropTypes, fieldsPropTypes, errorsPropTypes } from '../propTypes';
import { tableHooks, TableControls } from '../../../../../basicEditor/tableControls';
import TabelRowCell from '../../../../../newEditor/tablePart/tabkeRowCell';
import CalcArea from '../../calcArea';

function TRow({
  rowIndex,
  onChange,
  row,
  fields,
  errors,
  highlights,
  readOnly,
  readOnlyFields,
}) {
  const channelMterial = tableHooks.useSelectorInputProps('channel_material', row, fields, errors, onChange, rowIndex, readOnly, readOnlyFields);
  const area = tableHooks.useStringInputProps('area', row, fields, errors, onChange, rowIndex, readOnly, readOnlyFields);
  const valueWind = tableHooks.useNumberInputProps('value_wind', row, fields, errors, onChange, rowIndex, readOnly, readOnlyFields);

  const [keyParam, setKeyParam] = useState('');
  const [paramVent, setParamVent] = useState({
    isDim: false,
    isDiam: false,
    diam: 0,
    x: 0,
    y: 0,
    note: area.value,

  });

  const setArea = useCallback((e, value) => {
    area.onChange(e, value);
  }, [area]);

  return (
    <>
      {keyParam && (
        <CalcArea
          keyParam={keyParam}
          setKeyParam={setKeyParam}
          paramArea={paramVent}
          setParamVent={setParamVent}
          setArea={setArea}
        />
      )}

      <Row className="px-0 d-flex">
        <Col xl={4} lg={4}>
          <TabelRowCell
            column="channelMterial"
            highlighted={highlights.includes('channelMterial')}
          >
            <TableControls.SelectorInput {...channelMterial} />
          </TabelRowCell>
        </Col>
        <Col className="px-1">
          <TabelRowCell
            column="area"
            highlighted={highlights.includes('area')}
          >
            <TableControls.StringInput
              {...area}
              append={(
                <Button
                  variant="falcon-info"
                  size="sm"
                  onClick={() => setKeyParam('area')}
                >
                  <FontAwesomeIcon
                    icon={faCalculator}
                  />
                </Button>
              )}
            />
          </TabelRowCell>
        </Col>

        <Col xl={2} lg={2} className="px-0">
          <TabelRowCell
            column="valueWind"
            highlighted={highlights.includes('valueWind')}
          >
            <TableControls.NumberInput
              {...valueWind}
              precision={1}
            />
          </TabelRowCell>
        </Col>
      </Row>
    </>
  );
}

TRow.propTypes = {
  rowIndex: PropTypes.number.isRequired,
  row: PropTypes.shape(dataPropTypes).isRequired,
  errors: errorsPropTypes,
  onChange: PropTypes.func.isRequired,
  readOnlyFields: PropTypes.arrayOf(PropTypes.string),
  readOnly: PropTypes.bool,
  fields: fieldsPropTypes.isRequired,
  activeCol: PropTypes.string,
  highlights: PropTypes.arrayOf(PropTypes.string),
  onToggleHighlight: PropTypes.func.isRequired,

};

TRow.defaultProps = {
  errors: null,
  readOnlyFields: [],
  readOnly: false,
  activeCol: null,
  highlights: [],
};

export default memo(TRow);
